import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Flag = function Flag(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? '#6F4EF6' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M7 28.6001H5V48.0126H7V28.6001Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M32.375 30.9999C29.8375 30.9999 27.4 30.5124 25.1 29.5499L22.1375 28.2999C17.9625 26.5499 13.2 26.5749 9.0375 28.3749L5 30.1124V4.93739L8.2375 3.53739C12.8875 1.52489 18.225 1.49989 22.9 3.46239L25.8625 4.71239C27.925 5.57489 30.1 6.01239 32.325 6.01239C34.6375 6.01239 36.85 5.56239 38.9375 4.66239L43 2.92489V28.0999L39.725 29.4999C37.3875 30.4999 34.9125 30.9999 32.375 30.9999ZM15.6625 24.9999C18.1625 24.9999 20.6 25.4874 22.9 26.4499L25.8625 27.6999C27.925 28.5624 30.1 28.9999 32.325 28.9999C34.6375 28.9999 36.85 28.5499 38.9375 27.6499L41 26.7749V5.94989L39.725 6.49989C37.3875 7.49989 34.9125 7.99989 32.375 7.99989C29.8375 7.99989 27.4 7.51239 25.1 6.54989L22.1375 5.29989C17.9625 3.54989 13.2 3.57489 9.0375 5.37489L7 6.24989V27.0749L8.2375 26.5374C10.6 25.5124 13.1 24.9999 15.6625 24.9999Z",
      fill: secondaryColor
    })]
  });
};
export default Flag;